import { useOutletContext } from "react-router-dom";
import type { LeagueDetail } from "@/modules/leagues/types/league";

interface LeagueOutletContext {
  league: LeagueDetail;
}

/** Usado pelas páginas das abas (Feed/Palpites/Estatísticas/Configurações) para acessar a liga já carregada pelo LeagueShell, sem refetch. */
export function useLeagueContext() {
  return useOutletContext<LeagueOutletContext>();
}
